export default "__VITE_ASSET__DrLNECVZ__"